import { render } from "./UserInventory.vue?vue&type=template&id=352d6a3e&scoped=true"
import script from "./UserInventory.vue?vue&type=script&lang=js"
export * from "./UserInventory.vue?vue&type=script&lang=js"

import "./UserInventory.vue?vue&type=style&index=0&id=352d6a3e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-352d6a3e"]])

export default __exports__